import useIsMobile from '@/hooks/useIsMobile';
import useDebt from './useDebt';
import DebtDesktop from './desktop';
import DebtMobile from './mobile';

const Debt = ({ customer, onChange }) => {
  const isMobile = useIsMobile(768);
  const props = useDebt({ customer, onChange });
  return isMobile ? <DebtMobile {...props} /> : <DebtDesktop {...props} />;
};

export default Debt;
